import React from 'react';
//import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { Dimmer, Header, Icon, Segment, Form, Button, Message, Container } from "semantic-ui-react";
import * as Manger from './../../../../resources/Manger';


function NewImage(props) {

    const [título, setTítulo] = React.useState("");
    const [descrição, setDescrição] = React.useState("");
    const [botão, setBotão] = React.useState("");
    const [href, setHref] = React.useState("");
    const [image, setImage] = React.useState({ nome: "", image: null });
    const [e1, setE1] = React.useState(false);
    const [status, setForStatus] = React.useState("form");

    function reset(){
        setImage({nome:"",image:null});setTítulo("");setDescrição("");setBotão("");setHref("") ;setForStatus("form");
        props.update();
    }

    let aguarde = (
        <Message icon>
            <Icon name='circle notched' loading />
            <Message.Content>
                <Message.Header>Espere um momento</Message.Header>
                Estamos enviando o arquivo para o servidor.
        </Message.Content>
        </Message>
    );

    let sucesso = (
        <Message positive>
            <Message.Header>Sucesso!</Message.Header>
            <p>
                Tudo parece ter ocorrido perfeitamente como esperado.
        </p>
        </Message>
    );

    let falha = (
        <Message negative>
            <Message.Header>Falha!</Message.Header>
            <p>
                Algo deu errado, tente novamente.
        </p>
        </Message>
    );

    let form = (
        <Container>
            <Header as='h2' >
                <Icon name='area chart' />
                <Header.Content>
                    Nova Imagem
        </Header.Content>
                {/*<Icon name='close' style={{float:'right',marginTop:'-10%'}}/>*/}
            </Header>
            <Form as={Segment} size={'tiny'} style={{ textAlign: 'left' }}>
                <Form.Field >

                    <Form.Field>
                        <label>Título ({título.length}/60)*</label>
                        <input placeholder='Título da Imagem' value={título} onChange={ev => setTítulo(ev.target.value.substring(0,60))} />
                    </Form.Field>
                    <Form.Field>
                        <label>Descrição ({descrição.length}/30)*</label>
                        <input placeholder='Descrição da Imagem'  value={descrição} onChange={ev => setDescrição(ev.target.value.substring(0,30))} />
                    </Form.Field>
                    <Form.Field>
                        <label>Texto do Botão ({botão.length}/20)</label>
                        <input placeholder='Texto que deverá aparecer no botão' value={botão} onChange={ev => setBotão(ev.target.value.substring(0,20))} />
                    </Form.Field>
                    <Form.Field>
                        <label>Link do Botão</label>
                        <input placeholder='Ex: https://google.com.br' value={href} onChange={ev => setHref(ev.target.value)} />
                    </Form.Field>
                    <Form.Field>
                        <label>Carregar Imagem</label>
                        <input type="file" name="file-select" id="file-select" value={image.nome} onChange={ev => setImage({ image: ev.target.files[0], nome: ev.target.value })} />
                    </Form.Field>
                </Form.Field>
                {e1 ?
                    <Message negative>
                        <Message.Header>Atenção!</Message.Header>
                        <p>Todos os campos devem ser preenchidos devidademente, verifique se você selecionou uma imagem!</p>
                    </Message> : null}
                <Button primary content={'Enviar'} size={'tiny'} onClick={ev => {

                    let erro = false;
                    setE1(false);
                    if (título.length < 1) {
                        setE1(true);
                        erro = true;
                    }
                    if (descrição.length < 1) {
                        setE1(true);
                        erro = true;
                    }
                    if (image.nome.length < 1) {
                        setE1(true);
                        erro = true;
                    }

                    if (!erro) {
                        setForStatus("aguarde");
                        Manger.addCarrossel({título, descrição,botão,href})
                            .then(result => {
                                Manger.sendImage(image.image, result.carrossel.id)
                                    .then(result =>  {
                                        result = JSON.parse(result);
                                        props.update();
                                        if (result.status === "sucesso") {
                                            setForStatus('sucesso');
                                            console.log(result);
                                            setTimeout(()=>{reset();},4000);
                                        }
                                        else {
                                            console.log(result);
                                            setForStatus('falha');
                                            
                                        }
                                    }
                                    );
                            });
                    }
                }} />
                <Button secondary type={'Submit'} content={'Cancelar'} size={'tiny'} onClick={ev => { reset(); props.handleNew(false); }} />


            </Form>
        </Container>
    );

    return (
        <Dimmer active={props.active} onClickOutside={ev => {props.handleNew(false); reset();}}>


            <Segment style={{ width: '400px' }}>
                {status === "form" ? form : status === "aguarde" ? aguarde : status === "sucesso" ? sucesso : falha}
            </Segment>
        </Dimmer>
    );

}
export default NewImage;